import { Ad } from '../types/adType';

/**
 * Filters out inactive ads (sold or deleted) from an array.
 * An ad is considered active when is_deleted = false AND is_sold = false.
 * @param ads Array of ads to filter
 * @returns Filtered array with only active ads
 */
export const filterActiveAds = (ads: Ad[]): Ad[] => {
  return ads.filter(ad => {
    // Filter out deleted ads
    if (ad.is_deleted) return false;

    // Filter out sold ads
    if (ad.is_sold) return false;

    return true;
  });
};

/**
 * Checks if an ad is active (not sold and not deleted)
 * @param ad The ad to check
 * @returns True if the ad is active
 */
export const isAdActive = (ad: Ad): boolean => {
  return !ad.is_sold && !ad.is_deleted;
};

/**
 * Gets the status of an ad for display purposes
 * @param ad The ad to get status for
 * @returns Status string
 */
export const getAdStatus = (ad: Ad): string => {
  if (ad.is_deleted) return 'Supprimé';
  if (ad.is_sold) return 'Vendu';
  return 'Actif';
};

/**
 * Gets the appropriate message for sold or deleted ads
 * @param ad The ad to get message for
 * @returns Message string
 */
export const getAdStatusMessage = (ad: Ad): string => {
  if (ad.is_deleted) {
    return 'Cette annonce a été supprimée';
  }
  if (ad.is_sold) {
    return 'Cette annonce a été vendue';
  }
  return '';
};
